import { useQuery } from "@apollo/client";
import { GET_PROFILE_BY_USER_ID } from "../gql";
import type { Profile } from "@casey/db-types";

interface ProfileData {
  profileByUserId: Profile | null;
}

interface ProfileVariables {
  userId: string;
}

interface UseProfileByUserIdResult {
  profile: Profile | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useProfileByUserId(
  userId: string | null,
  options: { skip?: boolean } = {},
): UseProfileByUserIdResult {
  const { data, loading, error, refetch } = useQuery<
    ProfileData,
    ProfileVariables
  >(GET_PROFILE_BY_USER_ID, {
    variables: { userId: userId! },
    skip: !userId || options.skip,
    errorPolicy: "all",
  });

  return {
    profile: data?.profileByUserId || null,
    loading,
    error: error?.message || null,
    refetch: async () => {
      await refetch();
    },
  };
}
